export default __webpack_public_path__ + "static/media/Head.4c5c2daa.svg";